module.exports = __webpack_public_path__ + "static/amenities-lobby-1f01f3f38876b8d93a8c762ca46f9195.jpg";